<template>
<div class="animated fadeIn">
  <v-client-table :data="reservations" :columns="columns" :options="options" :theme="theme">
    <template slot="created_at" slot-scope="data">
      {{ $moment(data.row.created_at).format('YYYY-MM-DD') }}
    </template>
  </v-client-table>
</div>
</template>

<script>
import Vue from 'vue'
import {
  mapState,
} from 'vuex'


export default {
  name: "ReservationChildren",
  props: {
    reservations: Array
  },
  data() {
    return {
      columns: [
        'event_type.name',
        'id_card_no',
        'applicant_name',
        'members_count',
        'created_at',
        'arrival_date',
        'departure_date',
      ],
      options: {
        headings: {
          'event_type.name': 'Bhandara/Satsang',
          id_card_no: 'Id Card',
          applicant_name: 'Applicant',
          'members_count': 'Members',
          arrival_date: 'Arrival',
          departure_date: 'Departure',
        },
        sortable: [],
        filterable: [],
        sortIcon: {
          base: 'fa',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
          is: 'fa-sort'
        },
        pagination: {
          chunk: 5,
          edge: true,
          nav: 'scroll'
        },
        perPage: 25,
      },
      theme: 'bootstrap4',
    }
  }
}
</script>
